export const getPermissionForSection = (permissions: any[], sectionName: string) => {
    const sectionPermission = permissions.find(permission => permission.sectionName === sectionName);
    return sectionPermission ?? null;
  };
  